// Can't see any usages... Travis 2021-03-04

angular.module('wbFilters').filter('_utcDate', ['locale', (locale) => (input, format) => {
  if (format == null) { format = 'LL'; }
  if ((input == null) || !moment(input).isValid()) {
    return undefined;
  }

  if (format === 'monthDay') {
    const dateFormat = locale.isFrench() ? 'D MMMM' : 'MMMM Do';
    return moment(input).utc().format(dateFormat);
  } else {
    return moment(input).utc().format(format);
  }
}]);
